import * as React from 'react';
import * as ReactDOM from 'react-dom';
import DropdownTreeSelect from 'react-dropdown-tree-select';

// Wrapper that encapsulates the React DropdownTreeSelect component.
// Used when changing collections to select a collection with type ahead support.
export default class RateScheduleCollectionSelector extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.mountPoint = document.createElement("span");
    this.appendChild(this.mountPoint);

    this.selectedRateScheduleGroupId = this.getAttribute("data_selected_rate_schedule_group_id")
    this.selectedRateScheduleGroupId = parseInt(this.selectedRateScheduleGroupId)
  }

  update_collections(data) {
    // Make the current saved collection show as selected.
    data.map(collection => 
    {
      if (this.selectedRateScheduleGroupId === collection.value){
        collection.isDefaultValue = true
      }
    })

    this.component = ReactDOM.render(
      React.createElement(DropdownTreeSelect, 
        {
          texts: {
            placeholder: (data.length > 0 ) ? "Select a rate schedule collection..." : "No collections found."
          },
          data: data, 
          mode: "simpleSelect",
          onChange: this.selectionChanged.bind(this)
        }, 
        React.createElement("slot")),
      this.mountPoint
    );
  }

  // called when the selection changes and we broadcast to the parent container.
  selectionChanged(_currNode, selectedNodes) {
    this.dispatchEvent(new CustomEvent('collection_selection_changed', 
      {bubbles: true, composed: true, detail: {data: selectedNodes}}
    ))  
  }  
}

window.customElements.define("rate-schedule-collection-selector", RateScheduleCollectionSelector);
